import React from "react";
import { hydrate, render } from "react-dom";
// import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";

import store from "./store";

import ReactPixel from "react-facebook-pixel";

const advancedMatching = { em: "info@posh-market.ru" };
const options = {
  autoConfig: true,
  debug: false,
};
ReactPixel.init("442155386890988", advancedMatching, options);

ReactPixel.pageView();

const APP = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  hydrate(APP, rootElement);
} else {
  render(APP, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
